// API base URL is configured via REACT_APP_API_BASE_URL environment variable.
// Production: add REACT_APP_API_BASE_URL as a GitHub Secret in:
//   Repository → Settings → Secrets → Actions → devwhatsapp environment.
//   It gets injected into the bundle during `npm run build` in deploy.yml.
// Local dev: set REACT_APP_API_BASE_URL in .env.local (see .env.example).
const API_CONFIG = {
  
  BASE_URL: process.env.REACT_APP_API_BASE_URL || "https://wsapi.orkaapps.com",
  // BASE_URL: process.env.REACT_APP_API_BASE_URL || "https://wsdevapi.orkaapps.com",
  //  BASE_URL: process.env.REACT_APP_API_BASE_URL || "http://localhost:8081",
  // API Endpoints
  ENDPOINTS: {
    // Contact endpoints
    CONTACTS: {
      BASE: "/contacts",
      CREATE: "/contacts",
      GET_ALL: "/contacts",
      GET_BY_ID: (id) => `/contacts/${id}`,
      UPDATE: (id) => `/contacts/${id}`,
      DELETE: (id) => `/contacts/${id}`,
      BULK_DELETE: "/contacts/bulk-delete",
      IMPORT: "/contacts/import",
      EXPORT: "/contacts/export",
    },

    // Tag endpoints
    TAGS: {
      BASE: "/tags",
      CREATE: "/tags",
      GET_ALL: "/tags",
      GET_BY_ID: (id) => `/tags/${id}`,
      UPDATE: (id) => `/tags/${id}`,
      DELETE: (id) => `/tags/${id}`,
      POPULAR: "/tags/popular",
    },

    // Broadcast endpoints
    BROADCASTS: {
      BASE: "/broadcasts",
      CREATE: "/broadcasts",
      GET_ALL: "/broadcasts",
      GET_BY_ID: (id) => `/broadcasts/${id}`,
      UPDATE: (id) => `/broadcasts/${id}`,
      DELETE: (id) => `/broadcasts/${id}`,
      SEND: (id) => `/broadcasts/${id}/send`,
      SCHEDULE: (id) => `/broadcasts/${id}/schedule`,
    },

    // Template endpoints
    TEMPLATES: {
      BASE: "/templates",
      CREATE: "/templates",
      GET_ALL: "/templates",
      GET_BY_ID: (id) => `/templates/${id}`,
      UPDATE: (id) => `/templates/${id}`,
      DELETE: (id) => `/templates/${id}`,
      APPROVE: (id) => `/templates/${id}/approve`,
      REJECT: (id) => `/templates/${id}/reject`,
    },

    // Automation endpoints
    AUTOMATIONS: {
      BASE: "/automations",
      CREATE: "/automations",
      GET_ALL: "/automations",
      GET_BY_ID: (id) => `/automations/${id}`,
      UPDATE: (id) => `/automations/${id}`,
      DELETE: (id) => `/automations/${id}`,
      ACTIVATE: (id) => `/automations/${id}/activate`,
      DEACTIVATE: (id) => `/automations/${id}/deactivate`,
    },

    // Authentication endpoints
    AUTH: {
      LOGIN: "/auth/login",
      LOGOUT: "/auth/logout",
      REFRESH: "/auth/refresh",
      REGISTER: "/auth/register",
      FORGOT_PASSWORD: "/auth/forgot-password",
      RESET_PASSWORD: "/auth/reset-password",
      VERIFY_EMAIL: "/auth/verify-email",
    },

    // User endpoints
    USER: {
      PROFILE: "/user/profile",
      UPDATE_PROFILE: "/user/profile",
      CHANGE_PASSWORD: "/user/change-password",
      PREFERENCES: "/user/preferences",
    },
  },

  // Request configuration
  REQUEST: {
    TIMEOUT: 10000, // 10 seconds
    RETRY_ATTEMPTS: 3,
    RETRY_DELAY: 1000, // 1 second
  },

  // Pagination defaults
  PAGINATION: {
    DEFAULT_PAGE: 1,
    DEFAULT_LIMIT: 20,
    MAX_LIMIT: 100,
  },

  // File upload configuration
  UPLOAD: {
    MAX_FILE_SIZE: 10 * 1024 * 1024, // 10MB
    ALLOWED_TYPES: [
      "image/jpeg",
      "image/png",
      "image/gif",
      "application/pdf",
      "text/csv",
    ],
    ALLOWED_EXTENSIONS: [".jpg", ".jpeg", ".png", ".gif", ".pdf", ".csv"],
  },

  // Error messages
  ERROR_MESSAGES: {
    NETWORK_ERROR: "Network error. Please check your connection.",
    TIMEOUT_ERROR: "Request timeout. Please try again.",
    UNAUTHORIZED: "Unauthorized. Please log in again.",
    FORBIDDEN:
      "Access denied. You don't have permission to perform this action.",
    NOT_FOUND: "Resource not found.",
    VALIDATION_ERROR: "Please check your input and try again.",
    SERVER_ERROR: "Server error. Please try again later.",
    UNKNOWN_ERROR: "An unexpected error occurred.",
  },

  // Success messages
  SUCCESS_MESSAGES: {
    CONTACT_CREATED: "Contact created successfully",
    CONTACT_UPDATED: "Contact updated successfully",
    CONTACT_DELETED: "Contact deleted successfully",
    CONTACTS_DELETED: "Contacts deleted successfully",
    TAG_CREATED: "Tag created successfully",
    TAG_UPDATED: "Tag updated successfully",
    TAG_DELETED: "Tag deleted successfully",
    BROADCAST_CREATED: "Broadcast created successfully",
    BROADCAST_SENT: "Broadcast sent successfully",
    TEMPLATE_CREATED: "Template created successfully",
    TEMPLATE_UPDATED: "Template updated successfully",
    AUTOMATION_CREATED: "Automation created successfully",
    AUTOMATION_ACTIVATED: "Automation activated successfully",
    AUTOMATION_DEACTIVATED: "Automation deactivated successfully",
  },
};

export default API_CONFIG;
